import { combineActions, handleActions } from "redux-actions";

import { removeById, updateById } from "utils";

const floorplanSpaceReducer = handleActions(
  {
    FLOORPLANSPACE_CREATE: {
      PENDING: ({ floorplanSpaces }, { meta }) => ({
        floorplanSpaces: [...floorplanSpaces, meta.floorplanSpace],
      }),
      FULFILLED: ({ floorplan, floorplanSpaces, floorplans }, { payload }) => {
        const updatedSpaces = [...floorplan.floorplanSpaces, payload.floorplanSpace];
        const updatedFloorplan = {
          ...floorplan,
          floorplanSpaces: updatedSpaces,
        };

        return {
          floorplan: updatedFloorplan,
          floorplans: updateById(floorplans, updatedFloorplan),
          floorplanSpaces: [...floorplanSpaces, payload.floorplanSpace].filter(
            (f) => !f.isFinished
          ),
        };
      },
    },
    [combineActions("FLOORPLANSPACE_DELETE_PENDING", "FLOORPLANSPACE_DELETE_FULFILLED")]: (
      state,
      action
    ) => {
      const { floorplan, floorplanSpaces, floorplans } = state;
      const {
        meta: { floorplanSpaceID },
      } = action;

      const updatedSpaces = removeById(floorplan.floorplanSpaces, floorplanSpaceID);
      const updatedFloorplan = { ...floorplan, floorplanSpaces: updatedSpaces };

      return {
        floorplan: updatedFloorplan,
        floorplans: updateById(floorplans, updatedFloorplan),
        floorplanSpaces: removeById(floorplanSpaces, floorplanSpaceID),
      };
    },
    FLOORPLANSPACE_UPDATE: {
      PENDING: ({ floorplanSpaces }, { meta }) => ({
        floorplanSpaces: updateById(floorplanSpaces, meta.floorplanSpace),
      }),
      FULFILLED: ({ floorplan, floorplanSpaces, floorplans }, { payload }) => {
        const updatedSpaces = updateById(floorplan.floorplanSpaces, payload.floorplanSpace);
        const updatedFloorplan = {
          ...floorplan,
          floorplanSpaces: updatedSpaces,
        };

        return {
          floorplan: updatedFloorplan,
          floorplans: updateById(floorplans, updatedFloorplan),
          floorplanSpaces: updateById(floorplanSpaces, payload.floorplanSpace),
        };
      },
    },
  },
  {},
  { namespace: "_" }
);

export default floorplanSpaceReducer;
